/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NotificationDto,
    NotificationDtoFromJSON,
    NotificationDtoFromJSONTyped,
    NotificationDtoToJSON,
} from './NotificationDto';

/**
 * 
 * @export
 * @interface NotificationListDto
 */
export interface NotificationListDto {
    /**
     * 
     * @type {Array<NotificationDto>}
     * @memberof NotificationListDto
     */
    items: Array<NotificationDto>;
    /**
     * 
     * @type {number}
     * @memberof NotificationListDto
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationListDto
     */
    unreadCount: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationListDto
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationListDto
     */
    offset: number;
}

export function NotificationListDtoFromJSON(json: any): NotificationListDto {
    return NotificationListDtoFromJSONTyped(json, false);
}

export function NotificationListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(NotificationDtoFromJSON)),
        'total': json['total'],
        'unreadCount': json['unreadCount'],
        'limit': json['limit'],
        'offset': json['offset'],
    };
}

export function NotificationListDtoToJSON(value?: NotificationListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(NotificationDtoToJSON)),
        'total': value.total,
        'unreadCount': value.unreadCount,
        'limit': value.limit,
        'offset': value.offset,
    };
}

